var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, Type } from '@decahedron/entity';
import { PublicInfo } from './PublicInfo';
import { MediaAsset } from 'packages/media/MediaAsset';
import { Unit } from 'packages/users/Unit';
var Company = /** @class */ (function (_super) {
    __extends(Company, _super);
    function Company() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.hubspotId = null;
        _this.name = null;
        _this.lang = 'fi-FI';
        _this.status = null;
        _this.createdAt = null;
        _this.taId = null;
        _this.updatedAt = null;
        _this.logoMediaAsset = null;
        _this.bannerMediaAsset = null;
        _this.publicInfo = null;
        _this.units = [];
        _this.unitId = null;
        return _this;
    }
    Object.defineProperty(Company.prototype, "companyUnit", {
        get: function () {
            var _a;
            return (_a = this.units) === null || _a === void 0 ? void 0 : _a[0];
        },
        set: function (unit) {
            this.units[0] = unit;
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b, _c;
    __decorate([
        Type(MediaAsset),
        __metadata("design:type", typeof (_a = typeof MediaAsset !== "undefined" && MediaAsset) === "function" ? _a : Object)
    ], Company.prototype, "logoMediaAsset", void 0);
    __decorate([
        Type(MediaAsset),
        __metadata("design:type", typeof (_b = typeof MediaAsset !== "undefined" && MediaAsset) === "function" ? _b : Object)
    ], Company.prototype, "bannerMediaAsset", void 0);
    __decorate([
        Type(PublicInfo),
        __metadata("design:type", typeof (_c = typeof PublicInfo !== "undefined" && PublicInfo) === "function" ? _c : Object)
    ], Company.prototype, "publicInfo", void 0);
    __decorate([
        Type(Unit),
        __metadata("design:type", Array)
    ], Company.prototype, "units", void 0);
    return Company;
}(Entity));
export { Company };
